/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendIdDto } from '../models/backend-id-dto';
import { projectTaxesTaxPrmsDestroy } from '../fn/taxes/project-taxes-tax-prms-destroy';
import { ProjectTaxesTaxPrmsDestroy$Params } from '../fn/taxes/project-taxes-tax-prms-destroy';
import { projectTaxesTaxPrmsPartialUpdate } from '../fn/taxes/project-taxes-tax-prms-partial-update';
import { projectTaxesTaxPrmsPartialUpdate$FormData } from '../fn/taxes/project-taxes-tax-prms-partial-update-form-data';
import { ProjectTaxesTaxPrmsPartialUpdate$FormData$Params } from '../fn/taxes/project-taxes-tax-prms-partial-update-form-data';
import { ProjectTaxesTaxPrmsPartialUpdate$Params } from '../fn/taxes/project-taxes-tax-prms-partial-update';
import { projectTaxesTaxPrmsPartialUpdate$XWwwFormUrlencoded } from '../fn/taxes/project-taxes-tax-prms-partial-update-x-www-form-urlencoded';
import { ProjectTaxesTaxPrmsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/taxes/project-taxes-tax-prms-partial-update-x-www-form-urlencoded';
import { projectTaxesTaxPrmsRetrieve } from '../fn/taxes/project-taxes-tax-prms-retrieve';
import { ProjectTaxesTaxPrmsRetrieve$Params } from '../fn/taxes/project-taxes-tax-prms-retrieve';
import { projectTaxesTaxPrmsUpdate } from '../fn/taxes/project-taxes-tax-prms-update';
import { projectTaxesTaxPrmsUpdate$FormData } from '../fn/taxes/project-taxes-tax-prms-update-form-data';
import { ProjectTaxesTaxPrmsUpdate$FormData$Params } from '../fn/taxes/project-taxes-tax-prms-update-form-data';
import { ProjectTaxesTaxPrmsUpdate$Params } from '../fn/taxes/project-taxes-tax-prms-update';
import { projectTaxesTaxPrmsUpdate$XWwwFormUrlencoded } from '../fn/taxes/project-taxes-tax-prms-update-x-www-form-urlencoded';
import { ProjectTaxesTaxPrmsUpdate$XWwwFormUrlencoded$Params } from '../fn/taxes/project-taxes-tax-prms-update-x-www-form-urlencoded';
import { projectTaxesUnblockTaxesVariantsCreate } from '../fn/taxes/project-taxes-unblock-taxes-variants-create';
import { projectTaxesUnblockTaxesVariantsCreate$FormData } from '../fn/taxes/project-taxes-unblock-taxes-variants-create-form-data';
import { ProjectTaxesUnblockTaxesVariantsCreate$FormData$Params } from '../fn/taxes/project-taxes-unblock-taxes-variants-create-form-data';
import { ProjectTaxesUnblockTaxesVariantsCreate$Params } from '../fn/taxes/project-taxes-unblock-taxes-variants-create';
import { projectTaxesUnblockTaxesVariantsCreate$XWwwFormUrlencoded } from '../fn/taxes/project-taxes-unblock-taxes-variants-create-x-www-form-urlencoded';
import { ProjectTaxesUnblockTaxesVariantsCreate$XWwwFormUrlencoded$Params } from '../fn/taxes/project-taxes-unblock-taxes-variants-create-x-www-form-urlencoded';
import { BackendTaxPrmDto } from '../models/backend-tax-prm-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiTaxesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectTaxesTaxPrmsRetrieve()` */
  static readonly ProjectTaxesTaxPrmsRetrievePath = '/api/project_taxes/tax_prms/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxPrmsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTaxesTaxPrmsRetrieve$Response(
    params: ProjectTaxesTaxPrmsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxPrmDto>> {
    return projectTaxesTaxPrmsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxPrmsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTaxesTaxPrmsRetrieve(
    params: ProjectTaxesTaxPrmsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendTaxPrmDto> {
    return this.projectTaxesTaxPrmsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxPrmDto>): BackendTaxPrmDto => r.body),
    );
  }

  /** Path part for operation `projectTaxesTaxPrmsUpdate()` */
  static readonly ProjectTaxesTaxPrmsUpdatePath = '/api/project_taxes/tax_prms/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxPrmsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesTaxPrmsUpdate$Response(
    params: ProjectTaxesTaxPrmsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxPrmDto>> {
    return projectTaxesTaxPrmsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxPrmsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesTaxPrmsUpdate(
    params: ProjectTaxesTaxPrmsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendTaxPrmDto> {
    return this.projectTaxesTaxPrmsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxPrmDto>): BackendTaxPrmDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxPrmsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesTaxPrmsUpdate$XWwwFormUrlencoded$Response(
    params: ProjectTaxesTaxPrmsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxPrmDto>> {
    return projectTaxesTaxPrmsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxPrmsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesTaxPrmsUpdate$XWwwFormUrlencoded(
    params: ProjectTaxesTaxPrmsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendTaxPrmDto> {
    return this.projectTaxesTaxPrmsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxPrmDto>): BackendTaxPrmDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxPrmsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesTaxPrmsUpdate$FormData$Response(
    params: ProjectTaxesTaxPrmsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxPrmDto>> {
    return projectTaxesTaxPrmsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxPrmsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesTaxPrmsUpdate$FormData(
    params: ProjectTaxesTaxPrmsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendTaxPrmDto> {
    return this.projectTaxesTaxPrmsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxPrmDto>): BackendTaxPrmDto => r.body),
    );
  }

  /** Path part for operation `projectTaxesTaxPrmsDestroy()` */
  static readonly ProjectTaxesTaxPrmsDestroyPath = '/api/project_taxes/tax_prms/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxPrmsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTaxesTaxPrmsDestroy$Response(
    params: ProjectTaxesTaxPrmsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectTaxesTaxPrmsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxPrmsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTaxesTaxPrmsDestroy(params: ProjectTaxesTaxPrmsDestroy$Params, context?: HttpContext): Observable<void> {
    return this.projectTaxesTaxPrmsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `projectTaxesTaxPrmsPartialUpdate()` */
  static readonly ProjectTaxesTaxPrmsPartialUpdatePath = '/api/project_taxes/tax_prms/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxPrmsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesTaxPrmsPartialUpdate$Response(
    params: ProjectTaxesTaxPrmsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxPrmDto>> {
    return projectTaxesTaxPrmsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxPrmsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesTaxPrmsPartialUpdate(
    params: ProjectTaxesTaxPrmsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendTaxPrmDto> {
    return this.projectTaxesTaxPrmsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxPrmDto>): BackendTaxPrmDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxPrmsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesTaxPrmsPartialUpdate$XWwwFormUrlencoded$Response(
    params: ProjectTaxesTaxPrmsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxPrmDto>> {
    return projectTaxesTaxPrmsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxPrmsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesTaxPrmsPartialUpdate$XWwwFormUrlencoded(
    params: ProjectTaxesTaxPrmsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendTaxPrmDto> {
    return this.projectTaxesTaxPrmsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxPrmDto>): BackendTaxPrmDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesTaxPrmsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesTaxPrmsPartialUpdate$FormData$Response(
    params: ProjectTaxesTaxPrmsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendTaxPrmDto>> {
    return projectTaxesTaxPrmsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesTaxPrmsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesTaxPrmsPartialUpdate$FormData(
    params: ProjectTaxesTaxPrmsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendTaxPrmDto> {
    return this.projectTaxesTaxPrmsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendTaxPrmDto>): BackendTaxPrmDto => r.body),
    );
  }

  /** Path part for operation `projectTaxesUnblockTaxesVariantsCreate()` */
  static readonly ProjectTaxesUnblockTaxesVariantsCreatePath = '/api/project_taxes/unblock-taxes-variants/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesUnblockTaxesVariantsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesUnblockTaxesVariantsCreate$Response(
    params: ProjectTaxesUnblockTaxesVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return projectTaxesUnblockTaxesVariantsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesUnblockTaxesVariantsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesUnblockTaxesVariantsCreate(
    params: ProjectTaxesUnblockTaxesVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.projectTaxesUnblockTaxesVariantsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesUnblockTaxesVariantsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesUnblockTaxesVariantsCreate$XWwwFormUrlencoded$Response(
    params: ProjectTaxesUnblockTaxesVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return projectTaxesUnblockTaxesVariantsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesUnblockTaxesVariantsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesUnblockTaxesVariantsCreate$XWwwFormUrlencoded(
    params: ProjectTaxesUnblockTaxesVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.projectTaxesUnblockTaxesVariantsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesUnblockTaxesVariantsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesUnblockTaxesVariantsCreate$FormData$Response(
    params: ProjectTaxesUnblockTaxesVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return projectTaxesUnblockTaxesVariantsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesUnblockTaxesVariantsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesUnblockTaxesVariantsCreate$FormData(
    params: ProjectTaxesUnblockTaxesVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.projectTaxesUnblockTaxesVariantsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }
}
